import { render, staticRenderFns } from "./create-maintenance-order.vue?vue&type=template&id=45aa0d28&"
import script from "./create-maintenance-order.vue?vue&type=script&lang=js&"
export * from "./create-maintenance-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports